let $skipNav;
let $targetItems;
const navItems = [];

function cacheDOM() {
  $skipNav = document.querySelector('.js-skip-nav');
  $targetItems = document.querySelectorAll('[data-skip-nav-item');
}

function injectItems() {
  const $list = Object.assign(
    document.createElement('a'),
    {
      className: 'nav-skip__items',
    },
  );
  navItems.forEach((item) => {
    const $listItem = Object.assign(
      document.createElement('li'),
      {
        className: 'nav-skip__item',
      },
    );
    $listItem.appendChild(item.linkElm);
    $list.appendChild($listItem);
  });
  $skipNav.appendChild($list);
}

function resetActiveItems() {
  if (!navItems.length) return;
  navItems.forEach((item) => {
    item.linkElm.classList.remove('nav-skip__link--is-active');
  });
}

function setActiveItem(itemID) {
  const activeItem = navItems.find((item) => item.id === itemID);
  if (!activeItem) return;
  resetActiveItems();
  activeItem.linkElm.classList.add('nav-skip__link--is-active');
}

function initNav() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setActiveItem(entry.target.id);
      }
    });
  }, {
    threshold: 0.25, // 25% of the target element needs to be in the viewport
    rootMargin: '0% 0% -20% 0%', // Target must be past 20% of bottom of viewport
  });

  $targetItems.forEach(($item) => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    const itemTitle = $item?.dataset?.skipNavItem ?? false;
    if ($item.id && itemTitle) {
      const $linkElm = Object.assign(
        document.createElement('a'),
        {
          className: 'nav-skip__link',
          innerText: itemTitle,
          href: `#${$item.id}`,
        },
      );
      $linkElm.addEventListener('click', () => {
        resetActiveItems();
        $linkElm.classList.add('nav-skip__link--is-active');
      });
      const itemObj = {
        title: $item.dataset.skipNavItem,
        id: $item.id,
        linkElm: $linkElm,
      };
      navItems.push(itemObj);
      observer.observe($item);
    }
  });
  if (navItems.length) injectItems();
}

export default function init() {
  cacheDOM();
  if ($skipNav && $targetItems && $targetItems.length) initNav();
}
